export default {
  title: 'Documentos'
}
